<template>
    <div class="group-term-edit form-material" v-if="record">
      <h2>{{ isNewRecord ? 'Create Record' : 'Edit Record' }}</h2>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="language">Language</label>
            <input type="text" class="form-control" id="language" v-model="record.Language" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="url">URL</label>
            <input type="text" class="form-control" id="url" v-model="record.URL">
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="form-group">
            <label>Description</label>
            <rich-text-editor v-model="record.Description"></rich-text-editor>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="btn-group" role="group">
            <button type="submit" class="btn btn-primary" @click="saveRecord">Save</button>
            <button type="button" class="btn btn-secondary" @click="cancel">Cancel</button>
            <button type="button" class="btn btn-danger" @click="deleteRecord" v-if="!isNewRecord">Delete</button>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import RecordMixin from '@/components/tools/RecordMixin.vue';
  import RichTextEditor from '@/components/tools/RichTextEditor.vue';
  export default {
    name: 'GroupTermEdit',
    mixins: [RecordMixin],
    components: {
      RichTextEditor,
    },
    props: ['id'],
    data() {
      return {
        record: {
          Language: '',
          Description: '',
          URL: '',
        },
        table: 'groupterm',
      };
    },
  }
  </script>

  <style scoped>
  .group-term-edit {
    margin: 0 auto;
    padding: 20px;
  }
  </style>
